import { AppLoadingScreen } from "../components/layout/AppLoadingScreen";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { PRODUCT_NAME, useAuthBrand, type AuthBrand } from "./authBrand";

/* Branded full-screen loader shown while auth status resolves, before we know
 * whether to redirect to /login or render the dashboard. Uses the product's
 * Overview loading screen so the whole boot sequence (auth → workspace →
 * filters) shows one consistent loader — labelled for the product the viewer
 * is headed to (OPSS-487), so a /harness visit never flashes "Gateway". */

const TAGLINE: Record<AuthBrand, string> = {
  gateway: "Optimizing your agents",
  harness: "Finding your agent's sweet spot",
};

export function AuthSplash() {
  const brand = useAuthBrand();
  useDocumentTitle(`AI21 ${PRODUCT_NAME[brand]}`);

  return (
    <AppLoadingScreen label={PRODUCT_NAME[brand]} tagline={TAGLINE[brand]} />
  );
}
